import React from 'react';
import withIcon from '../utilities/withIcon';

const IconWarning = () => {
  return (
    <g>
      <path d="m15.7051 12.9691-6.5513-11.2378a1.3042 1.3042 0 0 0 -2.3076 0l-6.5513 11.2387a1.3386 1.3386 0 0 0 -.0649 1.3638 1.3379 1.3379 0 0 0 1.2109.6313h13.1177a1.2682 1.2682 0 0 0 1.1465-1.9961zm-8.4551-7.5152a.75.75 0 0 1 1.5 0v4.3023a.75.75 0 1 1 -1.5 0zm.75 7.765a.875.875 0 1 1 .875-.875.875.875 0 0 1 -.875.875z" />
    </g>
  );
};

export default withIcon(IconWarning);
